import { Calculator, CalendarCheck, Wallet, Truck } from "lucide-react";

const steps = [
  {
    icon: Calculator,
    step: "01",
    title: "Instant Quote",
    desc: "Tell us your home size, move type, and add-ons. Get a real price range in 60 seconds. No phone tag.",
  },
  {
    icon: CalendarCheck,
    step: "02",
    title: "Lock Your Date",
    desc: "Submit your booking form — we call within 2 business hours to confirm details and finalize your written quote.",
  },
  {
    icon: Wallet,
    step: "03",
    title: "Pay $100 Deposit",
    desc: "Get a QuickBooks invoice by email. Pay online — your moving date is officially locked and the deposit applies to your final bill.",
  },
  {
    icon: Truck,
    step: "04",
    title: "We Show Up",
    desc: "On time, uniformed, wrapped truck ready. Cash, check, or Zelle for final payment — card adds 3.5%.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="bg-[#F5F3EC] py-24 lg:py-32 border-t border-[#DDD8C9]"
      data-testid="how-it-works-section"
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            <div className="overline">The Process</div>
            <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              From click to<br />
              <span className="text-[#5BB239]">"we're done"</span> in 4 steps.
            </h2>
            <p className="mt-6 text-[#5C635F] leading-relaxed max-w-md">
              No dispatcher runaround. No mystery fees at the end. Every step is transparent,
              every price is on paper, every promise is kept.
            </p>
            <div className="mt-8 flex items-center gap-3 text-sm">
              <div className="w-8 h-[2px] bg-[#5BB239]" />
              <span className="font-mono-label text-[10px] text-[#5C635F] tracking-widest">
                Avg. Total Timeline: 3–7 days
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="space-y-5">
              {steps.map((s, i) => (
                <div
                  key={s.step}
                  className="bg-white border border-[#DDD8C9] hover:border-[#5BB239] transition-colors group flex items-stretch"
                  data-testid={`how-step-${s.step}`}
                >
                  <div className="w-16 sm:w-20 flex-shrink-0 bg-[#151816] group-hover:bg-[#5BB239] transition-colors flex flex-col items-center justify-center py-6">
                    <s.icon className="w-6 h-6 text-white" strokeWidth={2.25} />
                    <div className="mt-2 font-mono-label text-[9px] text-white/60 group-hover:text-white/90 tracking-widest">
                      {s.step}
                    </div>
                  </div>
                  <div className="flex-1 p-5 lg:p-6">
                    <div className="font-mono-label text-[9px] text-[#5BB239] tracking-widest">
                      Step {s.step}
                    </div>
                    <div className="mt-1 font-display font-black text-xl lg:text-2xl tracking-tight text-[#151816]">
                      {s.title}
                    </div>
                    <p className="mt-2 text-sm text-[#5C635F] leading-relaxed">
                      {s.desc}
                    </p>
                    {i === steps.length - 1 && (
                      <div className="mt-4 pt-4 border-t border-[#DDD8C9] flex items-center gap-2">
                        <span className="w-2 h-2 bg-[#5BB239] animate-pulse" />
                        <span className="font-mono-label text-[10px] text-[#5C635F] tracking-widest">
                          Money-back if we&apos;re more than 30 min late without a call
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
